<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content" v-title data-title="我的借用记录_试剂采购库存管理系统">
      <div class="search-type">
        <div class="searchLine">
          <ul class="clearfix">
          <li>
            <img src="../../assets/images/searchIcon.png" alt="" />
            <input
              type="text"
              style="margin-right:15px"
              placeholder="请输入关键字"
              v-model="searchData.reagentName"
              @keyup.enter="borrowList"
            />

              <el-button
          class="cursorPointer"
          @click="borrowList"
        >  快速查询
        </el-button>
          </li>
        </ul>
        </div>
      </div>
      <el-row :gutter="0" v-if="this.backConfig">
        <el-col :span="18" style="margin-top: 8px;margin-left: 20px;">
          <el-button type="primary" size="small" @click="batchReagentBack">试剂归还</el-button>
        </el-col>
      </el-row>
      <div class="table-container">
        <el-table :data="borrowData" :header-cell-style="{background: '#F8FAFC',color: '#000000',fontWeight: 700,
            height: '54px',}" border style="width: 100%" class="supTable" @selection-change="handleSelectionChange">
          <template slot="empty">
            <img src="../../assets/images/emptyCabinet.png" class="empty" />
            <p>暂无领用信息</p>
          </template>
          <el-table-column type="selection" width="50" v-if="this.backConfig" :selectable="selecReagent"/>
          <el-table-column prop="code" label="试剂编号">
            <template slot-scope="scope">
              <span v-if="scope.row.code">{{scope.row.code}}</span>
              <span v-else>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reagentName" label="试剂名称">
          </el-table-column>
          
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
<!--          <el-table-column prop="cabName" label="试剂位置">-->
<!--            <template v-slot="scope">-->
<!--              <span v-if="scope.row.operation!=3">{{scope.row.cabName}}</span>-->
<!--              <span v-else>******</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="createUsername" label="领用"> </el-table-column>
          <el-table-column prop="borrowNum" label="领用剂量">
            <template v-slot="scope">
              <span v-if="scope.row.borrowNum > 0">{{scope.row.borrowNum}}{{$store.state.unit[scope.row.reagentWeightUnit]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="领用备注"> </el-table-column>
          <el-table-column prop="gmtOrder" label="线上预约时间" width="155px">
            <template v-slot="scope">
              <span v-if="null != scope.row.borrow">{{scope.row.borrow.subscribeTime}}</span>
              <span v-else>{{scope.row.gmtOrder}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="线上申领时间" width="155px">
            <template v-slot="scope">
              <span v-if="null != scope.row.borrow">{{scope.row.borrow.obtainTime}}</span>
              <span v-else>{{scope.row.gmtCreate}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gmtDelivery" label="领用出库时间" width="155px">
            <template v-slot="scope">
              <span v-if="null != scope.row.borrow">{{scope.row.borrow.leaveTime}}</span>
              <span v-else>{{scope.row.gmtDelivery}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUsername" label="归还人" :formatter="getCreateUsername"></el-table-column>
<!--          <el-table-column prop="" label="归还人"> </el-table-column>-->
          <el-table-column label="归还入库时间" width="155px">
            <template slot-scope="scope">
              <span v-if="null != scope.row.borrow">{{scope.row.borrow.giveBackTime}}</span>
              <span v-else-if="scope.row.backTime">{{scope.row.backTime | timeYMD }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        :dataTotal="total"
        :totalpage="totalpage"
        :pagesize="searchData.pageSize"
        @changePage="changePage"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      searchData: {
        reagentName: "",
        operation:'',
        pageNum: 1,
        pageSize: 10,
      },
      //勾选项
      selections: [],
      backConfig: null,
      version: null,
      borrowData: [],
      total: 0,
      totalpage: 0,
      userId:"",
    };
  },
  created() {
    this.borrowList();
  },
  filters: {
    timeYMD(str) {
      return moment(str).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    getCreateUsername(row){
      if(null != row.borrow && 5 == row.borrow.borrowStatus){
        return row.borrow.givebackUserName
      }else if (row.backTime != null & row.backTime != ''){
        return row.lastBackUserName
      }else {
        return null
      }
    },

    getRecord(){
      // 筛选
      this.searchData.pageNum = 1
      this.borrowList()
    },
    //领用列表
    borrowList() {
      let params = this.searchData;
      this.$apiFetch
        .get("/lockerBorrowRecord/queryBorrowRecord", params)
        .then((res) => {
          this.borrowData = res.data.page.list;
          this.backConfig = res.data.backConfig;
          this.version = res.data.version;
          this.total = res.data.page.total;
          this.totalpage = res.data.page.pages;
        });
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.borrowList();
    },
    handleSelectionChange(val) {
      this.selections = val;
    },
    batchReagentBack(){
      if (this.selections.length <= 0) {
        this.$message.warning("请先选择");
        return;
      }
      let ids = [];
      ids = this.selections.map((i) => i.reagentId);

      const params = {};
      params.reagentIds = ids;
      this.$confirm(
          "确认归还这"+this.selections.length+"个试剂吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$apiFetch.post('/lockerReagentFree/reagentGetAndBackMultiIds',params)
            .then((res) => {
              if(!res.data.code){
                this.$message.success("归还成功");
                this.borrowList();
              }else{
                this.$message.error(res.data.description)
              }
            })
            .catch((error) => {
              console.log(error)
            })
      });
    },
    selecReagent(row,index){
      return row.showBack;
    }
  },
};
</script>
<style lang="less" scoped>
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      float: left;
      width: 100%;
      position: relative;
      img {
        width: 14px;
        display: block;
        position: absolute;
        top: 11px;
        left: 9px;
      }
      input {
        width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }
      button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
}
.supTable {
  img {
    width: 100px;
    height: 100px;
  }
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
</style>

